
  <template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row" v-if="userData.permissions['insurance_patients']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-end">
              <div> 
                <b-button v-b-modal.new-insurance-package size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Insurance Package</b-button>
              </div>   
              <div>
                <b-button class="mx-2" v-b-modal.new-insurance-price size="sm" variant="info"><i class="mdi mdi-upload"></i> Import Price</b-button>
              </div>
              <div>
                <button @click="downloadCsv" class="btn btn-sm btn-secondary"> <i class="mdi mdi-download"></i>Download Price Template</button>
              </div>
            </div>
           <br>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(insurance)="data">
                  {{ data.item.insurance.name }}
                </template>
                <template #cell(insurance_id)="data">
                  {{ data.item.insurance.id }}
                </template>
                <!-- <template #cell(package_id)="data">
                  {{ data.item.package_services.id }}
                </template> -->
               
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.insurance_id,data.item.package_name)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.insurance.name,data.item.package_name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                   </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row justify-content-center">
          <div class="col-md-8 col-xl-6">
            <div>
              <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
              <center><span class="text-primary h6">You have no permission to View Refered Patients</span></center>
            </div>
          </div>
        </div>
      </div>
      
  
      <b-modal id="new-insurance-package" centered title="New Insurance Package" title-class="font-18" hide-footer>
          <form @submit.prevent="addInsurancePackage">
            <div class="form-group mb-2">
              <label>Insurance Company Name</label>
                 <b-form-select v-model="insurance_id" required :options="insurancecompanies" class="mb-3 form-control" value-field="id" text-field="name" :custom-label="customLabel" label="insurance_id"></b-form-select>

              </div>
              <div class="form-group mb-2">
              <label>Package Name</label>
              <!-- <b-form-select v-model="package_id" required :options="insurancepackages" class="mb-3 form-control" value-field="id" text-field="name" :custom-label="customLabel" label="package_id"></b-form-select> -->

              <input v-model="package_name" type="text" required class="form-control" />
              </div>
             
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-insurance-package')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>

              </div>
              
                   <br><br><center><span class="text-danger">{{ error }}</span></center>

              
          </form>
      </b-modal>
  
      <b-modal id="new-insurance-price" centered title="Upload Price" title-class="font-18" hide-footer>
          <form @submit.prevent= "UpLoadPrices">
            <div class="form-group mb-2">
              <label>Insurance Company Name</label>
                 <b-form-select v-model="insurance_id" required @input="FilterInsurancePackage" :options="insurancecompanies" class="mb-3 form-control" value-field="id" text-field="name" :custom-label="customLabel" label="insurance_id"></b-form-select>

              </div>
              <div class="form-group mb-2">
              <label>Package Name</label>
                <!-- <input v-model="package_id" type="text" required   class="form-control" /> -->
                <b-form-select v-model="package_id" required :options="insurancespackagescost"  class="mb-3 form-control" value-field="id" text-field="package_name" :custom-label="customLabel" label="package_name"></b-form-select> 

            </div>
             
            <div class="form-group my-2">
            <label>Select the File</label>
            <input type="file" v-on:change="onLogoChange" class="form-control" />
            </div>

              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-insurance-price')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-insurance-package" centered title="Edit Insurance Package" title-class="font-14" hide-footer>
          <form @submit.prevent="editInsurancePackage">
            <div class="form-group mb-2">
              <label>Insurance Company Name</label>
                <b-form-select v-model="insurance_id" required :options="insurancecompanies" class="mb-3 form-control" value-field="id" text-field="name" :custom-label="customLabel" label="insurance_id"></b-form-select>
              </div>
              <div class="form-group mb-2">
              <label>Package Name</label>
              <input v-model="package_name" type="text" required class="form-control" />
              </div>
              
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-insurance-package')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-insurance-package" centered title="Delete Insurance Package " title-class="font-18" hide-footer>
          <form @submit.prevent="removeInsurancePackage">
              <input v-model="id" type="hidden">
                Are you sure you want to delete <b>{{ package_name }}</b>  from <b>{{ insurance }}</b> Insurance package ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-insurance-package')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  // import Multiselect from "vue-multiselect";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import {packagesMethods,insurancesMethods, insurancesComputed, packagesComputed } from "@/state/helpers";
  // import { insurancesMethods, insurancesComputed } from "@/state/helpers";

  export default {
    page: {
      title: "Insurance Packages",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
     Layout,PageHeader,
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Insurance Packages",
        items: [ {text: "Dashboard",to: "/",}, {text: "Insurance Packagess",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: '', label: 'ID', visible: false },
            { key: 'insurance', label: 'Insurance Company', visible: true },
            { key: 'package_name', label: 'Package', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        insurance_id:'',
        package_name:'',
        name:'',
        insurance:'',
        package_id:'',
        error:'',
        insurancespackagescost:[],
       
      };
    },
    computed: {
      ...insurancesComputed,
      ...packagesComputed,
      List() { return this.insurancepackages.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.insurancepackages.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.insurancepackages.length>0) { a=false;} else { a=true;} return a },
     },
    mounted() {
      this.fetchInsurances();
      this.fetchInsurancePackages();
      this.TotalRows = this.insurancepackages.length;
      this.isBusy=false;
    },
    methods: {
      ...insurancesMethods,
      ...packagesMethods,
      customLabel ({ id, name }) {
        return `${id} – ${name} `
      },
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async FilterInsurancePackage() {

        let url = `/filterpackage/${this.insurance_id}`;

          await axios.get(url).then((response) => {

            this.insurancespackagescost = response.data.insurancespackagescost;
          })

        },
      edit(insurance_id,package_name){
       
        this.insurance_id=insurance_id;
        this.package_name=package_name;
        this.$bvModal.show('edit-insurance-package')
      },
      
     
      remove(id,insurance,package_name){
        this.id=id;
        this.insurance=insurance;
        this.package_name=package_name;
        this.$bvModal.show('delete-insurance-package')
      },
      async addInsurancePackage() { 
        this.error = "Saving Package";
        let formData = new FormData();
        formData.append("insurance_id", this.insurance_id);
        formData.append("package_name", this.package_name);
        let url = "/addinsurancepackage";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchInsurancePackages();
            this.$bvModal.hide('new-insurance-package');
            this.insurance_id="";
            this.package_name="";
            this.$toast.success("New Insurance Package Added");
            this.error="";
        }
        });
      },
      onLogoChange(e){ this.importprices = e.target.files[0]; },
    async UpLoadPrices() { 
        const config = { headers: { 'content-type': 'multipart/form-data' } };
        let formData = new FormData();
        formData.append("insurance_id", this.insurance_id);
        formData.append("package_id", this.package_id);
        formData.append("importprices", this.importprices);
        let url = "/uploadprices";
        await axios.post(url, formData, config).then((response) => {
        if (response.status == 200) {
            this.$swal({ title:'Success', text:response.data.message, icon:'success'});
            this.$bvModal.hide('new-insurance-price');
            this.importprices="";
            this.insurance_id="";
            this.package_id="";
          }
        });
      },
      
      async editInsurancePackage(){ 
      let formData = new FormData();
      // formData.append("id", this.id);
      formData.append("insurance_id", this.insurance_id);
      formData.append("package_name", this.package_name);
      let url = "/updateinsurancepackage";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInsurances();
          this.fetchInsurancePackages();
          this.$bvModal.hide('edit-insurance-package');
          this.insurance_id="";
            this.package_name="";
            this.$toast.success("Insurance Package Updated");
        }
      });
      },
      async removeInsurancePackage() { 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("insurance", this.insurance);
      formData.append("package_name", this.package_name);
      let url = "/removeinsurancepackage";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInsurancePackages();
          this.$bvModal.hide('delete-insurance-package');
          this.$toast.error("Insurance Package Deleted");
        }
      });
      },
      getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"prices/"+name;
      return imagelink;
    },
  
  openFilePicker(package_id) {
      // Trigger click on the hidden file input
      this.package_id = package_id;
      this.$refs.fileInput.click();
    },

   async downloadCsv() {
      // Make an HTTP GET request to the Laravel route
      axios.get('/download-csv')
        .then(response => {
          // Handle the response (e.g., trigger file download)
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'service_data.csv');
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          // Handle errors
          this.$toast.error('Error downloading CSV:', error);
        });
    },
 
    async handleFileChange(event) {
  let file = event.target.files[0];

  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append('package_id',this.package_id);

    // Send the file to the server for processing
    let response = await axios.post("/addinsuranceservices", formData);

    this.$toast.success("File uploaded successful:", response.data);
    // You can add further logic here, such as displaying a success message
  } catch (error) {
    this.$toast.error("Error uploading file:", error);
    // Handle error appropriately, e.g., display an error message
  }

  // Display the contents of the CSV/TXT file in an alert dialog
  // const reader = new FileReader();
  // reader.onload = (e) => {
  //   const text = e.target.result;
  //   const rows = text.split('\n');
  //   rows.forEach(row => {
  //     const columns = row.split(',');
  //     alert("Row content:", columns); // Display each row in an alert
  //   });
  // };
  // reader.readAsText(file);
}
    }
  };
  </script>

 